import * as React from "react";
import * as classNames from "classnames";
import {ResourceType} from "../../_helpers/data";
import Shop from "../../_data/models/Shop";
import User from "../../_data/models/User";
import {UsersRoutes} from "../../routes";

interface Props {
    toggleFollow: (id: number, follower_id: number, is_followed: boolean, model_type: string) => void;
    currentUserID: number;
    model: User | Shop;
    className: string;
}

const FollowComponent = (props: Props) => {
    const {toggleFollow, model, currentUserID, className} = props;
    let m = '';
    let check = false;
    let modelObj = null;
    if (model instanceof User) {
        modelObj = (model as User);
        m = ResourceType.user;
        check = currentUserID && currentUserID != modelObj.id && !modelObj.defaultFollowable;
    }
    else if (model instanceof Shop) {
        m = ResourceType.shop;
        modelObj = (model as Shop);
        check = currentUserID && currentUserID != modelObj.userId;
    }

    if (!currentUserID) {
        return <a href={UsersRoutes.sign_in()} className={classNames("button", className, "hollow")}>
            <i className="fa fa-plus fa-fw"/>&nbsp; Follow
        </a>
    }

    return (
    check && (
        <a onClick={() => toggleFollow(modelObj.id, currentUserID, modelObj.isFollowed, m)}
           className={classNames("button", className, {"hollow": !modelObj.isFollowed})}>
            {modelObj.isFollowed && 'Following'}
            {!modelObj.isFollowed && <span><i className="fa fa-plus fa-fw"/>&nbsp; Follow</span>}
        </a>)
    );
};
export default FollowComponent;


// WEBPACK FOOTER //
// ./app/client/_widgets/follow/FollowComponent.tsx